
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { Ripple } from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';
import './Sidebar.css'
import { logOut } from '../../store/authSlice';
import { getToken } from '../../util/Cookies';
import { getRoleFromToken } from '../../util/authUtils';
import { useNavigate } from 'react-router-dom';
import LOGO from '../assets/thurent-logo.svg'

export default function HeadlessDemo() {
    const [visible, setVisible] = useState(false);
    const btnRef1 = useRef(null);
    const btnRef2 = useRef(null);
    const btnRef3 = useRef(null);
    const btnRef4 = useRef(null);
    const navigate = useNavigate()
       const dispatch = useDispatch();
       const token = getToken();
      const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
      const role = token ? getRoleFromToken(token) : null;
  const user = useSelector((state) => state.user.userDetails);
   const logoutAccount = () => {
      dispatch(logOut()); 
      navigate("/");
      window.location.reload();
    };
    return (
        <div className="card flex ">
            <Button
  icon="pi pi-bars"
  onClick={() => setVisible(true)}
  className="p-button-text p-button-plain"
/>

            <Sidebar
                visible={visible}
                onHide={() => setVisible(false)}
                content={({ closeIconRef, hide }) => (
                    <div className="min-h-screen flex relative lg:static surface-ground">
                        <div id="app-sidebar-2" className="surface-section h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none" style={{ width: '280px' }}>
                            <div className="flex flex-column h-full">
                                <div className="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0">
                                    <span className="my-4 inline-flex align-items-center gap-2">
                                        <div className="th-nav__logo" onClick={() => {
                   if (isLoggedIn) {
      switch (role) {
        case "customer":
          navigate("/admin-dashboard");
          break;
        case "provider":
          navigate("/service-provider/dashboard");
          break;
        case "admin":
          navigate("/admin-dashboard");
          break;
        default:
          navigate("/"); // fallback
      }
    } else {
      navigate("/");
    }
              }
              }>
          <img src={LOGO} alt="thurent" width={"120px"} />
        </div>
                                        
                                    </span>
                                    <span>
                                        <Button type="button" ref={closeIconRef} onClick={(e) => hide(e)} icon="pi pi-times" rounded outlined className="h-2rem w-2rem"></Button>
                                    </span>
                                </div>
                             
                                    <div className="navbar_items" onClick={()=> navigate("/adminaccounts")}>
                                        <span>
                                            Admin acounts
                                        </span>
                                </div>
                                 <div className="navbar_items" onClick={()=> navigate("/Events")}>
                                        <span>
                                            Events
                                        </span>
                                </div>
                                   <div className="navbar_items" onClick={()=> navigate("/tent-services")}>
                                        <span>
                                            Tenthouse services
                                        </span>
                                </div>
                                  <div className="navbar_items" onClick={()=> navigate("/catering-items")}>
                                        <span>
                                            catering items
                                        </span>
                                </div>
                                {/* <div className="overflow-y-auto">
                                    <ul className="list-none p-3 m-0">
                                        <li>
                                            <StyleClass nodeRef={btnRef1} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                <div ref={btnRef1} className="p-ripple p-3 flex align-items-center justify-content-between text-600 cursor-pointer">
                                                    <span className="font-medium">FAVORITES</span>
                                                    <i className="pi pi-chevron-down"></i>
                                                    <Ripple />
                                                </div>
                                            </StyleClass>
                                            <ul className="list-none p-0 m-0 overflow-hidden">
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-home mr-2"></i>
                                                        <span className="font-medium">Dashboard</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-bookmark mr-2"></i>
                                                        <span className="font-medium">Bookmarks</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <StyleClass nodeRef={btnRef2} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                        <a ref={btnRef2} className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                            <i className="pi pi-chart-line mr-2"></i>
                                                            <span className="font-medium">Reports</span>
                                                            <i className="pi pi-chevron-down ml-auto mr-1"></i>
                                                            <Ripple />
                                                        </a>
                                                    </StyleClass>
                                                    <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                                                        <li>
                                                            <StyleClass nodeRef={btnRef3} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                                <a ref={btnRef3} className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                                    <i className="pi pi-chart-line mr-2"></i>
                                                                    <span className="font-medium">Revenue</span>
                                                                    <i className="pi pi-chevron-down ml-auto mr-1"></i>
                                                                    <Ripple />
                                                                </a>
                                                            </StyleClass>
                                                            <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                                                                <li>
                                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                                        <i className="pi pi-table mr-2"></i>
                                                                        <span className="font-medium">View</span>
                                                                        <Ripple />
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                                        <i className="pi pi-search mr-2"></i>
                                                                        <span className="font-medium">Search</span>
                                                                        <Ripple />
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                                <i className="pi pi-chart-line mr-2"></i>
                                                                <span className="font-medium">Expenses</span>
                                                                <Ripple />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-users mr-2"></i>
                                                        <span className="font-medium">Team</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-comments mr-2"></i>
                                                        <span className="font-medium">Messages</span>
                                                        <span className="inline-flex align-items-center justify-content-center ml-auto bg-blue-500 text-0 border-circle" style={{ minWidth: '1.5rem', height: '1.5rem' }}>
                                                            3
                                                        </span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-calendar mr-2"></i>
                                                        <span className="font-medium">Calendar</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-cog mr-2"></i>
                                                        <span className="font-medium">Settings</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul className="list-none p-3 m-0">
                                        <li>
                                            <StyleClass nodeRef={btnRef4} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                <div ref={btnRef4} className="p-ripple p-3 flex align-items-center justify-content-between text-600 cursor-pointer">
                                                    <span className="font-medium">APPLICATION</span>
                                                    <i className="pi pi-chevron-down"></i>
                                                    <Ripple />
                                                </div>
                                            </StyleClass>
                                            <ul className="list-none p-0 m-0 overflow-hidden">
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-folder mr-2"></i>
                                                        <span className="font-medium">Projects</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-chart-bar mr-2"></i>
                                                        <span className="font-medium">Performance</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                        <i className="pi pi-cog mr-2"></i>
                                                        <span className="font-medium">Settings</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div> */}
                                <div className="mt-auto">
                                    <hr className="mb-3 mx-3 border-top-1 border-none surface-border" />
                                    {/* <a  className="m-3 flex align-items-center cursor-pointer p-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                        <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
                                        <span className="font-bold">Amy Elsner</span>
                                    </a> */}
                            <div className="th-nav__login__container">
            {!isLoggedIn ? (
              <>
                <span
                  className="th-nav__auth"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  Log-in / Sign-Up
                </span>
              
              </>
            ) : (
              <>
                 
                <span
                  className="th-nav__auth flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={logoutAccount}
                >
                  Logout
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.54199 5.86067C2.54199 4.0044 4.09797 2.54199 5.96278 2.54199H9.6083C11.4737 2.54199 13.0298 4.00429 13.0298 5.86067V6.53232C13.0298 6.90009 12.7317 7.19822 12.3639 7.19822C11.9962 7.19822 11.698 6.90009 11.698 6.53232V5.86067C11.698 4.78711 10.7864 3.87378 9.6083 3.87378H5.96278C4.78554 3.87378 3.87378 4.787 3.87378 5.86067V13.873C3.87378 14.9467 4.78554 15.8599 5.96278 15.8599H9.61578C10.7896 15.8599 11.698 14.9499 11.698 13.8809V13.2021C11.698 12.8343 11.9962 12.5362 12.3639 12.5362C12.7317 12.5362 13.0298 12.8343 13.0298 13.2021V13.8809C13.0298 15.7332 11.4765 17.1917 9.61578 17.1917H5.96278C4.09798 17.1917 2.54199 15.7293 2.54199 13.873V5.86067ZM7.43664 9.67874C7.43664 9.31098 7.73478 9.01285 8.10254 9.01285H14.9132L14.0077 8.11137C13.7471 7.8519 13.7462 7.43028 14.0056 7.16966C14.2651 6.90903 14.6867 6.90809 14.9473 7.16756L16.991 9.20216C17.1149 9.32309 17.1919 9.49193 17.1919 9.67874C17.1919 9.8675 17.1133 10.0379 16.9871 10.1591L14.9474 12.1904C14.6868 12.4499 14.2652 12.4491 14.0057 12.1885C13.7462 11.9279 13.7471 11.5063 14.0076 11.2468L14.9135 10.3446H8.10254C7.73478 10.3446 7.43664 10.0465 7.43664 9.67874Z"
                      fill="#383838"
                    />
                  </svg>
                </span>
                {role !== "provider" && (<span
                  className="th-nav__auth flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/dashboard/my-account")}
                >
                  {user?.firstName || "User"}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.625 10C17.625 5.85757 14.2674 2.5 10.125 2.5C5.98257 2.5 2.625 5.85757 2.625 10C2.625 14.1416 5.98257 17.5 10.125 17.5C14.2674 17.5 17.625 14.1416 17.625 10Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.83496 16.1452C6.00524 14.8235 7.18091 13.356 10.0998 13.356C13.0512 13.356 14.2188 14.8317 14.3809 16.1695"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.8487 8.60558C12.8487 10.1226 11.6195 11.3518 10.1025 11.3518C8.58549 11.3518 7.35547 10.1226 7.35547 8.60558C7.35547 7.08857 8.58549 5.85938 10.1025 5.85938C11.6195 5.85938 12.8487 7.08857 12.8487 8.60558Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
)}
              </>
            )}
          </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            ></Sidebar>
        </div>
    )
}
        